import CurrentOrganization from './CurrentOrganization'

export default CurrentOrganization



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/Hotels24Tab/MappingTabs/CurrentOrganization/index.js